import { MobileFirebaseProviderContext } from './MobileFirebaseProviderContext';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

interface IMobileFirebaseProviderProps {
    children: JSX.Element | JSX.Element[];
}

function MobileFirebaseProvider(props: IMobileFirebaseProviderProps) {
    const location = useLocation();

    const firebaseToken: string = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const urlFirebaseToken = params.get('firebase_token');
        if (urlFirebaseToken) {
            cookies.set('firebase_token', urlFirebaseToken, { path: '/', maxAge: 60 * 60 * 24 * 365 });
        }
        return cookies.get('firebase_token') || '';
        // Calc firebase token only on init
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const value = useMemo(() => ({
        firebaseToken,
    }), [firebaseToken]);

    return <MobileFirebaseProviderContext.Provider value={value}>
        {props.children}
    </MobileFirebaseProviderContext.Provider>;
}

export default MobileFirebaseProvider;
